export default "__VITE_ASSET__CVcuwGI2__"